import React from "react";
import styled from "styled-components";
import { FaFacebookF, FaXTwitter, FaInstagram } from "react-icons/fa6";
import wrootLogo from "../assets/wroot-logo.png";
import { useNavigate } from "react-router";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <FooterWrapper>
      <div className="left">
        <div className="logo">
          <img src={wrootLogo} alt="Wroot Logo" />
        </div>
        <p className="desc">
          Every project, product and service supports reforestation, ecosystem recovery, and climate resilience. With impact growing world-wide.
        </p>
        <div className="socials">
          <div className="icon">
            <FaFacebookF />
          </div>
          <div className="icon">
            <FaXTwitter />
          </div>
          <a 
            href="https://www.instagram.com/wroot.llc/#" 
            target="_blank" 
            rel="noopener noreferrer"
            className="icon"
          >
            <FaInstagram />
          </a>
        </div>
      </div>

      <div className="links">
        <div className="section">
          <h4>Quick Links</h4>
          <ul>
            <li onClick={(e) => navigate("/")}>Home</li>
            <li onClick={(e) => navigate("/about-us")}>Company</li>
            <li onClick={(e) => navigate("/projects")}>Projects</li>
          </ul>
        </div>
        <div className="section">
          <h4>Legal</h4>
          <ul>
            <li onClick={(e) => navigate("/terms-of-service")}>Terms and Conditions</li>
            <li onClick={(e) => navigate("/privacy-policy")}>Privacy Policy</li>
            <li onClick={(e) => navigate("/contact-us")}>Contact Us</li>
          </ul>
        </div>
        {/* <div className="section">
          <h4>Services</h4>
          <ul>
            <li>Payment Methods</li>
            <li>Money-back</li>
            <li>Shipping</li>
            <li>Privacy Policy</li>
          </ul>
        </div> */}
      </div>

      <div className="bottom">
        All Rights Reserved 2025 | <span>Wroot</span>
      </div>
    </FooterWrapper>
  );
};

export default Footer;

// Styled Component
const FooterWrapper = styled.footer`
  padding: 4rem 1rem 0 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: var(--section-width);
  margin: var(--section-margin) auto;
  .left {
    flex: 1;
    min-width: 250px;

    .logo {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background-color: var(--primary-color);
      padding: 0.5rem 1rem;
      border-radius: 2rem;
      margin-bottom: 1.2rem;

      img {
        height: 18px;
        width: auto;
      }
    }

    .desc {
      color: #555;
      max-width: 400px;
      font-size: 0.95rem;
      line-height: 1.6;
      margin-bottom: 1.5rem;
    }

    .socials {
      display: flex;
      gap: 1rem;
      margin-bottom: 1rem;
      .icon {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        background-color: var(--primary-color);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #1c1c1c;
        font-size: 1.2rem;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
          background-color: #c3e765;
        }
      }
    }
  }

  .links {
    display: flex;
    gap: 4rem;
    flex-wrap: wrap;

    .section {
      min-width: 150px;

      h4 {
        color: #0d1509;
        margin-bottom: 1rem;
        font-weight: bold;
      }

      ul {
        list-style: none;
        padding: 0;

        li {
          margin-bottom: 0.7rem;
          color: #666;
          font-size: 0.95rem;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .bottom {
    width: 100%;
    margin-top: 3rem;
    font-size: 0.9rem;
    color: #666;

    span {
      font-weight: bold;
      color: #1c1c1c;
    }
  }
`;
